// @ts-check
/**
 * 企业微信 — 「加老师微信」 QR codes. Backend: features/wecom.
 *
 * Response Types
 * @typedef {import('./types').MeWecomQrResponse} MeWecomQrResponse
 * @typedef {import('./types').WecomQrForCodeResponse} WecomQrForCodeResponse
 */

import { apiRequest } from './base';

/**
 * The signed-in parent's own QR (settings, the post-claim card). `configured`
 * is false while WeCom isn't wired up, and the UI hides the section.
 * @returns {Promise<MeWecomQrResponse>}
 */
export function getMyWecomQr() {
  return apiRequest('/me/wecom-qr');
}

/**
 * The claim page's QR — public, no login required, keyed to the redemption
 * code itself so it can show before any account exists.
 * @param {string} code
 * @returns {Promise<WecomQrForCodeResponse>}
 */
export function getWecomQrForCode(code) {
  return apiRequest(`/wecom/qr-for-code?code=${encodeURIComponent(code)}`);
}
